import { render, staticRenderFns } from "./PaytmCallback.vue?vue&type=template&id=1f3a2d07&"
import script from "./PaytmCallback.vue?vue&type=script&lang=js&"
export * from "./PaytmCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports